import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/common/app';
/**
 * Parses the "user:1,group:2" storage format into a plain, synchronous list
 * of { kind, id } references. Does not touch the store — safe to call
 * before any async lookups.
 */
export function parseRecipients(raw) {
  if (!raw) {
    return [];
  }
  return raw.split(',').map(item => item.trim()).filter(Boolean).map(item => {
    const _item$split$map = item.split(':').map(part => part.trim()),
      _item$split$map2 = _slicedToArray(_item$split$map, 2),
      kind = _item$split$map2[0],
      id = _item$split$map2[1];
    return {
      kind: kind,
      id
    };
  }).filter(ref => (ref.kind === 'user' || ref.kind === 'group') && !!ref.id);
}

/**
 * Serializes a list of Group/User models back into the "user:1,group:2" format.
 */
export function serializeRecipients(recipients) {
  const serialized = recipients.map(recipient => {
    const kind = recipient.data.type === 'users' ? 'user' : 'group';
    return "".concat(kind, ":").concat(recipient.id());
  }).join(',');
  return serialized || null;
}

/**
 * Resolves parsed recipient refs into actual Group/User models.
 *
 * Groups are resolved synchronously from the store (already loaded on boot).
 * Users are resolved asynchronously via app.store.find.
 *
 * `isStale` is checked before every state mutation so callers can cancel
 * in-flight resolutions when the underlying selection changes (e.g. the
 * user switches notification type before the previous lookup finishes).
 *
 * `onEach` is called once per resolved recipient, `onDone` once all refs
 * (found or not) have settled.
 */
export function resolveRecipients(refs, onEach, onDone, isStale) {
  if (refs.length === 0) {
    onDone();
    return;
  }
  let remaining = refs.length;
  const settle = () => {
    remaining -= 1;
    if (remaining === 0 && !isStale()) {
      onDone();
    }
  };
  refs.forEach(ref => {
    if (ref.kind === 'group') {
      const group = app.store.getById('groups', ref.id);
      if (group && !isStale()) {
        onEach(group);
      }
      settle();
    } else {
      app.store.find('users', ref.id).then(user => {
        if (user && !isStale()) {
          onEach(user);
        }
      }).catch(() => {
        // Deleted/unknown user referenced by a stored default — ignore silently.
      }).finally(() => {
        settle();
      });
    }
  });
}
flarum.reg.add('huseyinfiliz-notificationhub', 'common/utils/recipients', { parseRecipients: parseRecipients,serializeRecipients: serializeRecipients,resolveRecipients: resolveRecipients, });